module.exports = __webpack_public_path__ + "media/images/app/homepage/weddings/guests-e34e55cab339cbc353a2d1257070b585.webp";